import { computed, Directive, effect, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';
import { injectCustomClassSettable } from '@spartan-ng/ui-core';

import type { ClassValue } from 'clsx';

export const hlmDialogOverlayClass =
    'tw-bg-background/90 data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0';

@Directive({
    selector: '[hlmDialogOverlay],brn-dialog-overlay[hlm]',
    standalone: true
})
export class HlmDialogOverlayDirective {
    private readonly _classSettable = injectCustomClassSettable({ optional: true, host: true });

    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected readonly _computedClass = computed(() => sonaHlm(hlmDialogOverlayClass, this.userClass()));

    constructor() {
        effect(() => {
            this._classSettable?.setClassToCustomElement(this._computedClass());
        });
    }
}
